module.exports = __webpack_public_path__ + "img/top.96703430.png";